import styled from "styled-components";

export const ScrollbarWrapper = styled.div(() => ({
    width: "100%",
    display:'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent:'center',
    height: "85vh",
    overflowY: "scroll",
    overflowX:'hidden',
    scrollbarColor: "white blue",
    direction: "rtr",  // if you want to show the scroll bar on the left 
    gap:5,
    "::-webkit-scrollbar": {
        width: "8px",
    },
    "::-webkit-scrollbar-track": {
        boxShadow: "nset 0 0 6px grey",
        borderRadius: "5px"
    },
    "::-webkit-scrollbar-thumb": {
        background: '#005596',
        borderRadius: "15px",
        height: "2px"
    },
    "::-webkit-scrollbar-thumb:hover": {
        background: '#11b3e8',
        maxHeight: "10px"
    },
    "::-webkit-scrollbar-button:vertical:start:decrement": {
        background: `url(${process.env.PUBLIC_URL}/static/icons/arrow-example.png) no-repeat center center`,
        display: "block",
        backgroundSize: "10px"
    },
    "::-webkit-scrollbar-button:vertical:end:increment": {
        display: "block",
        background: `url(${process.env.PUBLIC_URL}/static/icons/arrow-example.png) no-repeat center center`,
        backgroundSize: "10px"
    },
}))

export const Content = styled.div(() => ({
    width:'100%',
    direction: "rtr",   // if you want to show the scroll bar on the left 
}))

export default ScrollbarWrapper